export const getAssetURL = url => {
    const mustUseCache = process.env.REACT_APP_REACT_APP_USE_CACHE;

    if (mustUseCache === 'true') {
        return url?.replace('a.storyblok.com', 'static.lupa.news');
    } else {
        return url;
    }
};
